import { render, staticRenderFns } from "./NoticeDetails.vue?vue&type=template&id=337a6d90&scoped=true&"
import script from "./NoticeDetails.vue?vue&type=script&lang=js&"
export * from "./NoticeDetails.vue?vue&type=script&lang=js&"
import style0 from "./NoticeDetails.vue?vue&type=style&index=0&id=337a6d90&scoped=true&lang=less&"
import style1 from "./NoticeDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337a6d90",
  null
  
)

export default component.exports